export default "__VITE_ASSET__CwlHfVxy__"